import React from "react";
import {
  Checkbox,
  FormControl,
  FormHelperText,
  Typography,
  Box,
  makeStyles,
} from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CircleUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import {
  Controller,
  useFormContext,
  useController,
  get,
} from "react-hook-form";
import Error from "../components/Error/Error";

const useStyles = makeStyles({
  checkBoxStyles: {
    width: '100%',
    marginTop: 15,

    "& .MuiButtonBase-root": {
      color: "#D1D1D1",
      padding: 0,
    },

    "& .MuiCheckbox-colorSecondary.Mui-checked": {
      color: ({ name }) => (name === "applyProtection" ? "#00C908" : "#00C908"),
    },
  },
  checkBoxLabel: {
    fontFamily: "sbcBold",
    fontSize: "1.6rem",
    lineHeight: 1.4,
    fontWeight: "bold",
    color: "#282F36",
  }
});

const CustomCheckbox = ({ ...props }) => {
  const classes = useStyles({ name: props.name });
  const { meta } = useController(props);
  const { control, formState } = useFormContext();
  const error = get(formState.errors, props.name);
  const errorText = meta.invalid ? error.message : "";
  return (
    <FormControl error={!!errorText} className={classes.checkBoxStyles}>
      <Box display="flex" alignItems="center" gridGap={10} ml={1}>
        <Controller
          {...props}
          control={control}
          render={(props) => (
            <Checkbox
              name={props.name}
              icon={<CircleUnchecked />}
              checkedIcon={<CheckCircleIcon />}
              onChange={(e) => {
                props.onChange(e.target.checked)
              }}
              defaultChecked={props.value}
            />
          )}
        />
        <Typography for={props.name} className={classes.checkBoxLabel}>{props.label}</Typography>
      </Box>
      <FormHelperText>
        {errorText && <Error errorMessage={errorText} />}
      </FormHelperText>
    </FormControl>
  );
};

export default CustomCheckbox;
